import { render, staticRenderFns } from "./FiltersSectionCustomsDashboard.vue?vue&type=template&id=531e0cfd&"
import script from "./FiltersSectionCustomsDashboard.vue?vue&type=script&lang=js&"
export * from "./FiltersSectionCustomsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531e0cfd')) {
      api.createRecord('531e0cfd', component.options)
    } else {
      api.reload('531e0cfd', component.options)
    }
    module.hot.accept("./FiltersSectionCustomsDashboard.vue?vue&type=template&id=531e0cfd&", function () {
      api.rerender('531e0cfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/invoices/FiltersSectionCustomsDashboard.vue"
export default component.exports